import {
  CREATE_PLC_SAFETY_ZONE_DEPENDENCY,
  CREATE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL,
  CREATE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED,
} from './actionTypes';

const initialState = {
  createPlcSafetyZoneDependencyError: null,
  messagePlcSafetyZoneDependency: null,
  loadingCreatePlcSafetyZoneDependency: false,
};

const createZoneDependency = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PLC_SAFETY_ZONE_DEPENDENCY:
      state = { ...state, loadingCreatePlcSafetyZoneDependency: true, createPlcSafetyZoneDependencyError: null };
      break;
    case CREATE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL:
      state = {
        ...state,
        loadingCreatePlcSafetyZoneDependency: false,
        messagePlcSafetyZoneDependency: action.payload,
        createPlcSafetyZoneDependencyError: null,
      };
      break;
    case CREATE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED:
      state = {
        ...state,
        messagePlcSafetyZoneDependency: null,
        loadingCreatePlcSafetyZoneDependency: false,
        createPlcSafetyZoneDependencyError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createZoneDependency;
